import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "application",
  "use": "application-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol viewBox=\"0 0 22 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"application\"><path clip-rule=\"evenodd\" d=\"M14.75 19.6h-5l.625-3.6h3.75l.625 3.6v0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M7.875 19.6h8.75M10.375 5.2h8.75c.69 0 1.25.536 1.25 1.2v8.4c0 .662-.56 1.2-1.25 1.2H5.375c-.69 0-1.25-.538-1.25-1.2v-1.2M4.125 13.6h16.25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M1.625 3.1a1.5 1.5 0 011.5-1.5h3.25a1.5 1.5 0 011.5 1.5v6.6a1.5 1.5 0 01-1.5 1.5h-3.25a1.5 1.5 0 01-1.5-1.5V3.1z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M1.625 8.8h6.25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/application.svg
// module id = KDOV
// module chunks = 39 44